import {useSelector} from "react-redux";
import {RootState} from "../../store";

export type WorkflowIds = {
  getUserWorkflowId: string;
  getStatesWorkflowId: string;
  getCitiesWorkflowId: string;
  getVendorsWorkflowId: string;
  getCommodityTypesWorkflowId: string;
  updateShipmentItemsInsuranceWorkflowId?: string;
  createPaymentWorkflowId?: string;
  applyCreditWorkflowId?: string;
  getContactAddressWorkflowId: string;
};

export const useWorkflowIds = (): WorkflowIds => {
  const workflows = useSelector(
    (state: RootState) => state.organizationConfigState?.workflows,
  );

  return {
    getUserWorkflowId: workflows?.getUserWorkflowId || "",
    getStatesWorkflowId: workflows?.getStatesWorkflowId || "",
    getCitiesWorkflowId: workflows?.getCitiesWorkflowId || "",
    getVendorsWorkflowId: workflows?.getVendorsWorkflowId || "",
    getCommodityTypesWorkflowId: workflows?.getCommodityTypesWorkflowId || "",
    updateShipmentItemsInsuranceWorkflowId:
      workflows?.updateShipmentItemsInsuranceWorkflowId || "",
    createPaymentWorkflowId: workflows?.createPaymentWorkflowId || "",
    applyCreditWorkflowId: workflows?.applyCreditToInvoices || "",
    getContactAddressWorkflowId: workflows?.getContactAddressWorkflowId || "",
  };
};
